export default function returnHome() {
    window.location.hash = "/";
}
